export default [
  // 在线
  {
    name: 'STATUS_ONLINE',
    value: 1
  },
  // 离线
  {
    name: 'STATUS_OFFLINE',
    value: 2
  },
  // 正常
  {
    name: 'STATUS_NORMAL',
    value: 1
  },
  // 异常
  {
    name: 'STATUS_UNNORMAL',
    value: 2
  },
  // 宿主机发布
  {
    name: 'PUBLISH_METHOD_HOST',
    value: 1
  },
  // Docker 发布
  {
    name: 'PUBLISH_METHOD_DOCKER',
    value: 2
  },
]